import { isValidQuestionnaireName } from '../../../utils/isValidQuestionnaireName'
import type {
  QuestionnaireStrategy,
  QuestionnaireSelectionResult,
  SelectionContext,
} from '../types'

/**
 * Strategy: Extract questionnaire from defaultFormResults prop
 * Priority: Second (2nd)
 *
 * Behavior:
 * - Valid questionnaire in defaultFormResults → use it and stop chain
 * - Invalid questionnaire explicitly provided → fallback to 'default' and stop chain
 * - No questionnaire in defaultFormResults → continue to next strategy
 */
export const createDefaultFormResultsStrategy = (): QuestionnaireStrategy => ({
  name: 'defaultFormResults',

  execute: (context: SelectionContext): QuestionnaireSelectionResult => {
    const defaultQuestionnaire = context.defaultFormResults.questionnaire

    if (typeof defaultQuestionnaire !== 'string') {
      return {
        questionnaire: null,
        shouldContinue: true,
        reason: 'No questionnaire in defaultFormResults',
      }
    }

    if (isValidQuestionnaireName(defaultQuestionnaire)) {
      return {
        questionnaire: defaultQuestionnaire,
        shouldContinue: false,
        reason: 'Valid questionnaire found in defaultFormResults',
      }
    }

    return {
      questionnaire: 'default',
      shouldContinue: false,
      reason: 'Invalid questionnaire in defaultFormResults, using default',
    }
  },

  isEnabled: () => true,
})
